import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="EVA system initialization sequence"
      visualizer="full"
      autoNext={10000}
      transition="fade"
      terminal={{
        phases: [
          {
            type: 'command',
            content: './initialize_eva.sh',
          },
          {
            type: 'command',
            content: 'Initializing neural network [OK]',
          },
          {
            type: 'progress',
            content: 'Loading knowledge database...',
            duration: 2500,
          },
          {
            type: 'command',
            content: 'Modules:',
          },
          {
            type: 'command',
            content: '- network [OK]',
          },
          {
            type: 'command',
            content: '- core [OK]',
          },
          {
            type: 'command',
            content: '- vision [ERROR]',
          },
          {
            type: 'command',
            content: 'Rerouting...',
          },
          {
            type: 'command',
            content: '- vision [OK]',
          },
          {
            type: 'access',
            content: 'E̲nterprise V̲irtual A̲ssistant READY',
          },
        ],
        config: {
          title: 'EVA',
          typingSpeed: 30,
          phaseDelay: 300,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
